import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../base_svg-icon/component';
import Text from '@text';

import './styles.scss';

const EbookNotice = ({ product, store }) => {
  const { ebookType } = product;
  if (!ebookType) {
    return null;
  }

  const texts = {
    name: `ebook.format.${ebookType}.name`,
    description: `ebook.format.${ebookType}.description`,
    required: `ebook.format.${ebookType}.required`,
    optional: `ebook.format.${ebookType}.optional`,
  };

  const showPanel = () => {
    store.modal.openModal('sidepanel', 'right', {
      title: <Text>{texts.name}</Text>,
      component: (
        <div>
          <p><Text>{texts.description}</Text></p>
          <strong><Text>ebook.info.label.required</Text></strong>
          <p><Text>{texts.required}</Text></p>
          <strong><Text>ebook.info.label.optional</Text></strong>
          <p><Text>{texts.optional}</Text></p>
        </div>
      ),
    });
  };

  return (
    <div className="ebook-notice" onClick={showPanel}>
      <div className="notice">
        <Icon name="ico-info-filled" size={150}/>
        <div>
          <div className="notice-title"><Text>{texts.name}</Text></div>
          <p><Text>ebook.notification.text</Text></p>
        </div>
      </div>
      <div className="notice-label">
        <Text>ebook.notification.label</Text>
      </div>
    </div>
  );
};

EbookNotice.propTypes = {
  store: PropTypes.object,
  product: PropTypes.object,
};

export default EbookNotice;
